module.exports = __webpack_public_path__ + "img/logo_heineken.76d045d3.png";